<template>
  <div>
    <!-- First Navbar -->
    <v-app-bar app class="px-4 py-2" elevation="1">
      <v-img 
        src="@/assets/logo.jpeg" 
        alt="Logo" 
        contain 
        class="logo"
        max-height="70"
        max-width="300"
      ></v-img>
      
      <v-spacer></v-spacer>
      
      <!-- Desktop Navigation -->
      <div class="nav-links d-none d-md-flex">
        <router-link to="/" exact-active-class="active-link" class="nav-link me-4">Home</router-link>
        <router-link to="/about" exact-active-class="active-link" class="nav-link me-4">About BPS</router-link>
        <router-link to="/news" exact-active-class="active-link" class="nav-link me-4">News</router-link>
        <router-link to="/contact" exact-active-class="active-link" class="nav-link">Contact Us</router-link>
      </div>

      <!-- Mobile Menu Button -->
      <v-app-bar-nav-icon
        class="d-md-none"
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>
    </v-app-bar>

    <!-- Mobile Navigation Drawer -->
    <v-navigation-drawer
      v-model="drawer"
      app
      temporary
      class="d-md-none"
    >
      <v-list>
        <v-list-item to="/" @click="drawer = false">
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item>
        <v-list-item to="/about" @click="drawer = false">
          <v-list-item-title>About BPS</v-list-item-title>
        </v-list-item>
        <v-list-item to="/news" @click="drawer = false">
          <v-list-item-title>News</v-list-item-title>
        </v-list-item>
        <v-list-item to="/contact" @click="drawer = false">
          <v-list-item-title>Contact Us</v-list-item-title>
        </v-list-item>
        
        <v-divider class="my-2"></v-divider>
        
        <!-- Mobile Services Menu -->
        <v-list-group>
          <template v-slot:activator="{ props }">
            <v-list-item v-bind="props" title="Services"></v-list-item>
          </template>
          
          <v-list-item to="/season-parking" @click="drawer = false" class="pl-8">
            <v-list-item-title>Season Parking</v-list-item-title>
          </v-list-item>
          <v-list-item to="/parking-coupons" @click="drawer = false" class="pl-8">
            <v-list-item-title>Parking Coupons</v-list-item-title>
          </v-list-item>
          <v-list-item to="/find-bps-booth" @click="drawer = false" class="pl-8">
            <v-list-item-title>Find BPS Booth</v-list-item-title>
          </v-list-item>
          <v-list-item to="/parking-lots" @click="drawer = false" class="pl-8">
            <v-list-item-title>Parking Lots</v-list-item-title>
          </v-list-item>
          <v-list-item to="/search-parking-offence" @click="drawer = false" class="pl-8">
            <v-list-item-title>Parking Offence Notices</v-list-item-title>
          </v-list-item>
          <v-list-item to="/online-payment-guide" @click="drawer = false" class="pl-8">
            <v-list-item-title>Online Payment Guide</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <!-- Second Navbar - Desktop Only -->
    <v-app-bar app color="#2A2B7E" dark class="d-none d-md-flex" style="top: 80px;">
      <v-container fluid>
        <v-row align="center" no-gutters>
          <!-- Services Links - Desktop -->
          <v-col class="d-flex flex-wrap" cols="auto">
            <v-btn text size="small" :class="{'active-link': isActive('/season-parking')}" class="me-2">
              <router-link to="/season-parking" exact-active-class="active-link" class="inherit">
                Season Parking
              </router-link>
            </v-btn>
            <v-btn text size="small" :class="{'active-link': isActive('/parking-coupons')}" class="me-2">
              <router-link to="/parking-coupons" exact-active-class="active-link" class="inherit">
                Parking Coupons
              </router-link>
            </v-btn>
            <v-btn text size="small" :class="{'active-link': isActive('/find-bps-booth')}" class="me-2">
              <router-link to="/find-bps-booth" exact-active-class="active-link" class="inherit">
                Find BPS Booth
              </router-link>
            </v-btn>
            <v-btn text size="small" :class="{'active-link': isActive('/parking-lots')}" class="me-2">
              <router-link to="/parking-lots" exact-active-class="active-link" class="inherit">
                Parking Lots
              </router-link>
            </v-btn>
            <v-btn text size="small" :class="{'active-link': isActive('/search-parking-offence')}" class="me-2">
              <router-link to="/search-parking-offence" exact-active-class="active-link" class="inherit">
                Parking Offence Notices
              </router-link>
            </v-btn>
            <v-btn text size="small" :class="{'active-link': isActive('/online-payment-guide')}">
              <router-link to="/online-payment-guide" exact-active-class="active-link" class="inherit">
                Online Payment Guide
              </router-link>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
  </div>
</template>

<script>
  export default {
    name: 'NavigationBar',
    data() {
      return {
        drawer: false
      }
    },
    methods: {
      isActive(...routes) {
        return routes.includes(this.$route.path);
      }
    }
  };
</script>

<style scoped>
.nav-link {
  text-decoration: none;
  color: inherit;
  padding: 8px 0;
}

.active-link {
  font-weight: bold;
  color: lightblue !important;
}

.inherit {
  color: inherit !important;
  text-decoration: none;
}

/* Mobile responsive adjustments */
@media (max-width: 959px) {
  .logo {
    max-height: 44px !important;
    max-width: 140px !important;
  }
}
</style>